/**
 * ONNX Runtime WebAssembly uses a single global in-flight guard for inference.
 * Overlapping InferenceSession.run() calls (any session) throw "Session mismatch".
 * Queue all WASM runs through this helper.
 *
 * @template T
 * @param {() => Promise<T>} fn
 * @returns {Promise<T>}
 */
let ortRunChain = Promise.resolve();

export function runOrtInferenceSerialized(fn) {
    const p = ortRunChain.then(() => fn());
    ortRunChain = p.then(
        () => undefined,
        () => undefined
    );
    return p;
}
